import React from 'react';
import { CheckIcon, PackageCheckIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { volumes } from '../../data/content';
export function Volumes() {
  return <section className="bg-white px-4 py-16 md:px-8 md:py-24" data-id="element-319" data-mp="2x0qofuq9babu">
      <div className="mx-auto max-w-6xl" data-id="element-320" data-mp="2x3cutr1evjsh">
        <div className="mx-auto max-w-3xl text-center" data-id="element-321" data-mp="2t0g7jn0xezi7">
          <p className="text-sm font-extrabold uppercase tracking-wide text-brand-700" data-id="element-322" data-mp="2t1re1ulrald0">Your complete 6-volume clinical blueprint</p>
          <h2 className="mt-3 text-[28px] font-extrabold leading-tight tracking-tight text-ink-900 md:text-4xl" data-id="element-323" data-mp="2j9d78nftmojz">
            Everything you need to build a more structured retreatment assessment workflow
          </h2>
          <p className="mt-4 text-[17px] leading-relaxed text-mist-600" data-id="element-324" data-mp="29cqnk1z8e3jj">
            These aren't six theoretical textbooks. They're six practical toolkits designed to support qualified
            professionals in organizing clinical information and documenting individualized decisions.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-325" data-mp="334uku4p9svyg">
          {volumes.map(v => <article key={v.number} className="flex flex-col overflow-hidden rounded-3xl bg-mist-50 ring-1 ring-mist-200" data-id="element-326" data-mp="37x4he3kw4u9p">
              <div className="bg-ink-900 p-6 text-white" data-id="element-327" data-mp="2u6sjfo1mk1an">
                <span className="inline-block rounded-lg bg-brand-400 px-3 py-1 text-sm font-extrabold uppercase text-ink-950" data-id="element-328" data-mp="2y5rkuyo5dfxc">
                  Volume {v.number}
                </span>
                <h3 className="mt-3 text-[22px] font-extrabold leading-tight" data-id="element-329" data-mp="3qvqhbf4o8fc1">{v.title}</h3>
                <p className="mt-2 text-[15px] font-semibold text-brand-300" data-id="element-330" data-mp="3cvpe3t0xovte">{v.subtitle}</p>
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-331" data-mp="3htr0onxkjd9m">
                <p className="text-[16px] leading-relaxed text-mist-600" data-id="element-332" data-mp="3hwd72k8q3mq9">{v.description}</p>
                <p className="mt-5 text-sm font-extrabold uppercase text-ink-900" data-id="element-333" data-mp="21idb1kd00h8a">Inside this volume:</p>
                <ul className="mt-3 space-y-2.5" data-id="element-334" data-mp="26d0o8n2jxp7k">
                  {v.items.map(it => <li key={it} className="flex items-start gap-2.5 text-[15px] font-medium text-ink-800" data-id="element-335" data-mp="c19a3n56oe0m">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-600" strokeWidth={3} aria-hidden="true" data-id="element-336" data-mp="72eka18stp70" />
                      {it}
                    </li>)}
                </ul>
                <div className="mt-auto pt-6" data-id="element-337" data-mp="3pe1iedvphkcp">
                  <div className="flex items-start gap-3 rounded-2xl bg-cta-300/60 p-4" data-id="element-338" data-mp="3peujay7zhfmx">
                    <PackageCheckIcon className="h-6 w-6 shrink-0 text-ink-900" aria-hidden="true" data-id="element-339" data-mp="3kdx6701tzbsa" />
                    <p className="text-[15px] font-semibold leading-snug text-ink-900" data-id="element-340" data-mp="3fgn52n52xbom">
                      <span className="font-extrabold" data-id="element-341" data-mp="3bfbof746o0sk">Practical deliverable: </span>
                      {v.deliverable}
                    </p>
                  </div>
                </div>
              </div>
            </article>)}
        </div>

        <SectionCta label="Unlock all 6 clinical volumes" data-id="element-342" data-mp="19l2op2lnzkca" />
      </div>
    </section>;
}